import {Directive, HostListener, Input} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import Swal from 'sweetalert2';
import {LoadingService} from '../components/loading/loading.service';

/**
 * Descarga un archivo protegido con JWT.
 * Sustituye a `<a [href]="url" target="_blank">` en las exportaciones: el interceptor añade el Bearer
 * y el archivo se entrega como Blob con el nombre que indique Content-Disposition (o `fileName`).
 */
@Directive({
  selector: '[ngxAuthDownload]',
})
export class AuthDownloadDirective {
  @Input('ngxAuthDownload') url: string;
  @Input() fileName: string = null;
  private busy = false;

  constructor(private http: HttpClient, private loading: LoadingService) {
  }

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    event.preventDefault();
    if (!this.url || this.busy) return;
    this.busy = true;
    this.loading.showLoading.next(true);
    this.http.get(this.url, {observe: 'response', responseType: 'blob'}).subscribe((res: HttpResponse<Blob>) => {
      this.busy = false;
      this.loading.showLoading.next(false);
      const name = this.fileName || this.nameFromHeaders(res) || this.nameFromUrl(this.url);
      const a = document.createElement('a');
      a.href = URL.createObjectURL(res.body);
      a.setAttribute('download', name);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(a.href);
    }, err => {
      this.busy = false;
      this.loading.showLoading.next(false);
      const msg = (err && err.error && err.error.message) || 'No se pudo descargar el archivo.';
      Swal.fire({title: 'Incidencia', text: msg, icon: 'error', confirmButtonText: 'OK'});
    });
  }

  private nameFromHeaders(res: HttpResponse<Blob>): string | null {
    const cd = res.headers.get('content-disposition') || '';
    const m = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(cd);
    return m ? decodeURIComponent(m[1]) : null;
  }

  private nameFromUrl(url: string): string {
    const clean = url.split('?')[0];
    const last = clean.substring(clean.lastIndexOf('/') + 1) || 'descarga';
    return /\.[a-z0-9]{2,5}$/i.test(last) ? last : `${last}.xlsx`;
  }
}
